export default "__VITE_ASSET__Cp7yL4Z7__"